class BalperSaleCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = new Date(this.dataset.end || '').getTime();
    this.valueElement = this.querySelector('[data-countdown-value]');

    if (!Number.isFinite(this.endTime) || !this.valueElement) {
      this.hidden = true;
      return;
    }

    this.renderCountdown();
    this.timer = window.setInterval(() => this.renderCountdown(), 30000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  renderCountdown() {
    const millisecondsRemaining = this.endTime - Date.now();

    if (millisecondsRemaining <= 0) {
      this.hidden = true;
      window.clearInterval(this.timer);
      return;
    }

    const totalMinutes = Math.ceil(millisecondsRemaining / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');

    this.valueElement.textContent = days > 0
      ? `${days}d ${paddedHours}h ${paddedMinutes}m`
      : `${paddedHours}h ${paddedMinutes}m`;
    this.setAttribute(
      'aria-label',
      days > 0
        ? `La oferta termina en ${days} días, ${hours} horas y ${minutes} minutos`
        : `La oferta termina en ${hours} horas y ${minutes} minutos`,
    );
    this.hidden = false;
  }
}

if (!customElements.get('balper-sale-countdown')) {
  customElements.define('balper-sale-countdown', BalperSaleCountdown);
}
